(function() {
  const SHEET_URL = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vRkfVXMCSrw9KAWRcUOeVnpxpiR-8sbrxTZXv9yM855dRuqTJn8ITr2JdcfAKMbt3GXEmhw9jc4ZMfs/pub?gid=0&single=true&output=csv';
  
  let vehicleData = [];
  const modal = document.getElementById('v-modal-overlay');
  const closeBtn = document.querySelector('.v-modal-close');
  const resetBtn = document.getElementById('v-reset-btn');
  
  const makeSelect = document.getElementById('v-make');
  const modelSelect = document.getElementById('v-model');
  const yearSelect = document.getElementById('v-year');
  const resultsDiv = document.getElementById('v-results');
  const loader = document.getElementById('v-loader');

  document.addEventListener('click', function(e) {
    const trigger = e.target.closest('#openVehicleModal') || e.target.closest('#modalTrigger');
    
    if (trigger) {
      e.preventDefault();
      modal.style.display = 'block';
      if (vehicleData.length === 0) loadData();
    }
  });

  closeBtn.onclick = () => modal.style.display = 'none';
  window.onclick = (e) => { if (e.target == modal) modal.style.display = 'none'; };

  async function loadData() {
    loader.innerText = "Connecting to database...";
    try {
      const response = await fetch(SHEET_URL);
      if (!response.ok) throw new Error('Network error');
      const csvText = await response.text();
      vehicleData = parseCSV(csvText);
      if (vehicleData.length > 0) {
        populateMakes();
        loader.classList.add('v-hidden');
      }
    } catch (err) {
      loader.innerText = "Error: Could not read sheet.";
    }
  }

  function parseCSV(text) {
    const lines = text.split(/\r?\n/).filter(line => line.trim() !== "");
    const headers = lines[0].split(',').map(h => h.replace(/^"|"$/g, '').trim());
    return lines.slice(1).map(line => {
      const values = [];
      let current = '', inQuotes = false;
      for (let char of line) {
        if (char === '"') inQuotes = !inQuotes;
        else if (char === ',' && !inQuotes) { values.push(current.trim()); current = ''; }
        else current += char;
      }
      values.push(current.trim());
      const obj = {};
      headers.forEach((h, i) => obj[h] = (values[i] || "").replace(/^"|"$/g, ''));
      return obj;
    });
  }

  function populateMakes() {
    makeSelect.innerHTML = '<option value="">-- Choose Make --</option>';
    const makes = [...new Set(vehicleData.map(item => item.Make))].filter(Boolean).sort();
    makes.forEach(m => {
      const opt = document.createElement('option');
      opt.value = opt.textContent = m;
      makeSelect.appendChild(opt);
    });
  }

  makeSelect.onchange = () => {
    modelSelect.disabled = !makeSelect.value;
    modelSelect.innerHTML = '<option value="">-- Choose Model --</option>';
    yearSelect.disabled = true;
    yearSelect.innerHTML = '<option value="">-- Choose Year --</option>';
    resultsDiv.classList.add('v-hidden');
    if (!makeSelect.value) return;
    const models = [...new Set(vehicleData.filter(d => d.Make === makeSelect.value).map(d => d.Model))].filter(Boolean).sort();
    models.forEach(m => {
      const opt = document.createElement('option');
      opt.value = opt.textContent = m;
      modelSelect.appendChild(opt);
    });
  };

  modelSelect.onchange = () => {
    yearSelect.disabled = !modelSelect.value;
    yearSelect.innerHTML = '<option value="">-- Choose Year --</option>';
    resultsDiv.classList.add('v-hidden');
    if (!modelSelect.value) return;
    const years = [...new Set(vehicleData.filter(d => d.Make === makeSelect.value && d.Model === modelSelect.value).map(d => d.Year))].filter(Boolean);
    years.forEach(y => {
      const opt = document.createElement('option');
      opt.value = opt.textContent = y;
      yearSelect.appendChild(opt);
    });
  };

  let currentTotalCredits = 0;
  const SHOPIFY_VARIANT_ID = '41414586433675'; 

  yearSelect.onchange = () => {
    const match = vehicleData.find(d => 
      d.Make === makeSelect.value && d.Model === modelSelect.value && d.Year === yearSelect.value
    );
    if (match) {
      // 1. Calculate and display totals
      const credits = parseInt(match['Credits'] || '0', 10);
      const tcmCredits = parseInt(match['TCM Credits'] || '0', 10);
      currentTotalCredits = credits + tcmCredits;

      // 2. Handle ECM Logic text
      let ecmValue = match['ECM'] || 'N/A';
      if (ecmValue.trim().toUpperCase() === 'Y') {
        ecmValue = "May require ECM unlock / service";
      }

      // 3. Update UI elements
      document.getElementById('v-res-credits').innerText = credits;
      document.getElementById('v-res-tcm-credits').innerText = tcmCredits;
      document.getElementById('v-res-ecm').innerText = ecmValue;
      document.getElementById('v-res-notes').innerText = match['Notes'] || 'N/A';
      document.getElementById('v-res-tcm-notes').innerText = match['TCM Notes'] || 'N/A';
      
      // 4. Update and Show the AJAX Button
      const cartBtn = document.getElementById('v-add-to-cart-btn');
      const btnCount = document.getElementById('v-button-count');

      // Only run the logic if BOTH elements are found in the DOM
      if (cartBtn && btnCount) {
        if (currentTotalCredits > 0) {
          btnCount.innerText = currentTotalCredits;
          cartBtn.style.display = 'inline-block';
        } else {
          cartBtn.style.display = 'none';
        }
      }

      resultsDiv.classList.remove('v-hidden'); // Show the results container
    }
  };

// 5. AJAX Click Handler
  const addToCartBtn = document.getElementById('v-add-to-cart-btn');
  
  if (addToCartBtn) {
    addToCartBtn.onclick = async function() {
      const btn = this;
      const msg = document.getElementById('v-cart-msg');
      
      btn.disabled = true;
      btn.innerText = "ADDING...";

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            'items': [{ 'id': SHOPIFY_VARIANT_ID, 'quantity': currentTotalCredits }]
          })
        });

        if (response.ok) {
          if (msg) {
            msg.innerText = "Added to cart successfully!";
            msg.style.display = "block";
          }
          
          document.dispatchEvent(new CustomEvent('cart:updated', {
              bubbles: true,
              detail: { cart: await response.json() }
          }));
        }
      } catch (error) {
        if (msg) {
          msg.innerText = "Error adding to cart.";
          msg.style.display = "block";
        }
      } finally {
        btn.disabled = false;
        btn.innerHTML = `ADD <span id="v-button-count">${currentTotalCredits}</span> CREDITS TO CART`;
      }
    };
  }

  resetBtn.onclick = () => {
    makeSelect.value = "";
    makeSelect.onchange();
  };
})();